var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ backgroundColor: '#F5F7FA' })},[_c('Header'),(_vm.isInitializing)?_c('div',{staticClass:"app-loading-screen"},[_c('p',[_vm._v("Loading application...")])]):_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }